module.exports = __webpack_public_path__ + "static/media/logo-grey.ea09c436.svg";